module.exports = __webpack_public_path__ + "static/media/2-solution-1.eaf0c720.mp3";